/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in 
*                 part without express written permission of Honeywell Inc. 
*                 is prohibited.
*
* Name          : AcceptTermsCheck.tsx
* 
* Project Title : Checkout
*  
* Description   : Initial version
* 
* Company       : Honeywell Technology Solutions , Hyderabad
* 
* @Author       : H224423
* 
* @Date         : Nov 28, 2019
*
* @Version      : Version 1.0
* 
* By           : H224423
* On           : Nov 28, 2019
* Description  : ASDS-1474 Accept product terms changes.
* 
* By           : H224423
* On           : Nov 28, 2019
* Description  : ASDS-1474 Addressed code review comments. Added props.
 * 
 * By            : H224423
 * On            : Dec 3, 2019
 * Description   : ASDS-1995 - UI Issue Fixes.  
 * 
 * By            : H224423
 * On            : Dec 17 2019
 * Description   : UT Automation 
 * 
*******************************************************************************/

import * as React from 'react';
import { Grid, Checkbox } from '@scuf/common';

interface IAcceptTermsCheck {
    acceptTermsStatus: boolean;
    checkboxLabel: string;
    updateAcceptTermsStatus: Function;
    acceptTermsErrorMsg: string;
}

function AcceptTermsCheck (props: IAcceptTermsCheck) {
    return (
        <Grid>
            <Grid.Row>
                <Grid.Column className="accept-terms-check confirm-checkbox" width={12}>
                    <Checkbox
                        id="accept-terms-checkbox"
                        checked={props.acceptTermsStatus}
                        label={props.checkboxLabel}
                        onChange={(checked) => props.updateAcceptTermsStatus(checked)}
                    />
                    {props.acceptTermsErrorMsg && <div className="below-text"><span className="ui error-message">{props.acceptTermsErrorMsg}</span></div>} 
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
}
export default AcceptTermsCheck;